import { render, staticRenderFns } from "./creditDatagramDetail.vue?vue&type=template&id=ab21e0ce&scoped=true"
import script from "./creditDatagramDetail.vue?vue&type=script&lang=js"
export * from "./creditDatagramDetail.vue?vue&type=script&lang=js"
import style0 from "./creditDatagramDetail.vue?vue&type=style&index=0&id=ab21e0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab21e0ce",
  null
  
)

export default component.exports